// extracted by mini-css-extract-plugin
export default {"title":"FaqSection_title__BFZXm"};